module.exports = __webpack_public_path__ + "img/withdraw.17c62123.svg";